<template lang="pug">
  component(
    :is="component"
    v-bind="bindings"
    v-on="listeners"
    ref="input"
    )
</template>

<script>
import BaseDatepicker from '@/components/BaseDatepicker.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseSelectMulti from '@/components/BaseSelectMulti.vue';
import BaseInput from '@/components/BaseInput.vue';
import BasePhoneInput from '@/components/BasePhoneInput.vue';
import BaseTextarea from '@/components/BaseTextarea.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';

import BaseUserField from '@/components/base/BaseUserField.vue';

// Справочник грузим асинхронно: он сам умеет открывать форму, собранную из
// BaseField, и статический импорт замкнул бы модули в кольцо.
const BaseDir = () => import('@/components/base/BaseDir.vue');

export default {
  name: 'BaseField',
  components: {
    BaseInput,
    BaseDatepicker,
    BaseSelect,
    BaseSelectMulti,
    BaseTextarea,
    BasePhoneInput,
    BaseCheckbox,
    BaseUserField,
  },
  props: {
    value: [String, Date, Number, Boolean, Array],
    type: String,
    label: String,
    error: String,
    options: [Object, Array],
    disabled: Boolean,
    name: String,
    autocomplete: String,
    unit: String,
    labelOuter: Boolean,
    config: Object,
    filter: Object,
    context: Object,
    hideNotSelected: Boolean,
    emptyLabel: String,
    // права на правку справочника, см. BaseDir
    canCreate: { type: Boolean, default: true },
    canEdit: { type: Function, default: () => true },
    canRemove: { type: Function, default: () => true },
  },
  computed: {
    // Пропы, специфичные для одного типа поля, отдаём только ему: у остальных
    // компонентов их нет, они осели бы в $attrs и вылезли атрибутами в разметке
    bindings() {
      const { value, type, label, error, options, disabled, name, autocomplete, unit, labelOuter } = this; // eslint-disable-line
      const base = { value, type, label, error, options, disabled, name, autocomplete, unit, labelOuter }; // eslint-disable-line

      switch (this.type) {
        case 'dir':
          return {
            ...base,
            config: this.config,
            filter: this.filter,
            context: this.context,
            canCreate: this.canCreate,
            canEdit: this.canEdit,
            canRemove: this.canRemove,
          };
        case 'select':
        case 'multi':
          return { ...base, hideNotSelected: this.hideNotSelected };
        case 'user':
          return { ...base, emptyLabel: this.emptyLabel };
        default:
          return base;
      }
    },
    component() {
      switch (this.type) {
        case 'date':
        case 'datetime':
          return BaseDatepicker;
        case 'select':
          return BaseSelect;
        case 'multi':
          return BaseSelectMulti;
        case 'textarea':
          return BaseTextarea;
        case 'tel':
          return BasePhoneInput;
        case 'checkbox':
          return BaseCheckbox;
        case 'dir':
          return BaseDir;
        case 'user':
          return BaseUserField;
        default:
          return BaseInput;
      }
    },
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => this.$emit('input', value),
      };
    },
  },
  methods: {
    focus() {
      this.$refs.input?.focus?.(); // eslint-disable-line
    },
  },
};
</script>

<style scoped>

</style>
